module.exports = {
	"header": "Spotin aims to revolutionize e-com",
	"date": "2018/12/14",
	"imgSrc": "no_image.jpg",
	"imgAlt": "Spotin aims to revolutionize e-com",
	"ingress": "By: Affärer i Norr (in Swedish)",
	"externalLink": "https://affarerinorr.se/nyheter/2018/december/spotin-vill-foeraendra-e-handeln/"
};


//////////////////
// WEBPACK FOOTER
// ./pages/media/2/article.json
// module id = 89
// module chunks = 0